/**
 * Created by 唐亦慧 on 2017/8/29.
 */
import {config, request, objectSerial} from 'Utils';


//获取地区列表
export function regionList(param) {
	return request(`${config.server}/api/v1/dms/region/tglist`,{
		method: 'post',
		body: param
	});
}


//获取指定地区详情
export function regionDetail(param) {
	return request(`${config.server}/api/v1/dms/region/detail?${objectSerial(param)}`);
}


//新增地区
/*
 {
 active (integer, optional): 是否有效(1有效0失效) ,
 fullPath (string, optional): 全路径 ,
 parentRegionId (integer, optional): '父id ,
 regionCode (string, optional): 地区编码 ,
 regionId (integer, optional): 地区id ,
 regionName (string, optional): 地区名称 ,
 regionPath (string, optional): id路径 ,
 sortOrder (integer, optional): 排序
 }
* */
export function regionAdd(param) {
	return request(`${config.server}/api/v1/dms/region/insert`,{
		method: 'post',
		body: param
	});
}


//修改地区
/*
* {
 active (integer, optional): 是否有效(1有效0失效) ,
 fullPath (string, optional): 全路径 ,
 id (integer, optional): 主id ,
 parentRegionId (integer, optional): '父id ,
 regionCode (string, optional): 地区编码 ,
 regionId (integer, optional): 地区id ,
 regionName (string, optional): 地区名称 ,
 regionPath (string, optional): id路径 ,
 sortOrder (integer, optional): 排序
 }
* */

export function regionModify(param) {
	return request(`${config.server}/api/v1/dms/region/modify`,{
		method: 'post',
		body: param
	});
}


//删除地区--传id
export function regionDelete(param) {
	return request(`${config.server}/api/v1/dms/region/delete`,{
		method: 'post',
		body: param
	});
}

//根据父id查询省、市、区、街道办
export function listByParentId(id) {
  return request(`${config.server}/api/v1/dms/region/listByParentId?id=${id}`);
}


//根据父id查询省、市、区、街道办树
export function treeByParentId(id) {
	return request(`${config.server}/api/v1/dms/region/treeListByParentId?id=${id}`);
}



// WEBPACK FOOTER //
// ./src/service/region/index.js